import angular from 'angular';
import ModalFactory from './modal.factory';

let modalModule = angular.module('app.ui', [])

.factory('Modal', ModalFactory)

.name;

export default modalModule;


// WEBPACK FOOTER //
// ./client/app/common/ui/modal/index.js